<template>
  <div id="download">
    <div class="container">
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.software") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.softwarein") }}</em></small
        >
      </div>
      <div class="space"></div>
      <div class="card" id="info">
        <div class="card-head">
          <div>{{ $t("index.downloadNavi") }}</div>
        </div>
        <div class="card-content">
          <div class="item">
            <div class="imgbox" :style="{ backgroundImage: 'url(' + imgsUrl[0] + ')' }">
              <div class="mask"></div>
              <div class="downloadbtn" @click="jump('bodorplus')">
                {{ $t("index.downloadInfo") }}
              </div>
            </div>
            <div class="bottom">
              <div class="title">Bodor+</div>
              <div class="text">{{ $t("index.downloadWc") }}</div>
            </div>
          </div>
          <div class="item">
            <div class="imgbox" :style="{ backgroundImage: 'url(' + imgsUrl[1] + ')' }">
              <div class="mask"></div>
              <div class="downloadbtn" @click="jump('bodornextnav')">
                {{ $t("index.downloadInfo") }}
              </div>
            </div>
            <div class="bottom">
              <div class="title">BodorNest</div>
              <div class="text">{{ $t("index.downloadNest") }}</div>
            </div>
          </div>
          <div class="item">
            <div class="imgbox" :style="{ backgroundImage: 'url(' + imgsUrl[2] + ')' }">
              <div class="mask"></div>
              <div class="downloadbtn" @click="jump('bodornesttubenav')">
                {{ $t("index.downloadInfo") }}
              </div>
            </div>
            <div class="bottom">
              <div class="title">BodorNest Tube</div>
              <div class="text">{{ $t("index.downloadTube") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

let router = useRouter();

localStorage.setItem("router", "software");
let isVisitor = localStorage.getItem("isVisitor");

const imgsUrl = ref([
  require("@/assets/img/software/app.png"),
  require("@/assets/img/software/BodorNest.png"),
  require("@/assets/img/software/BodorNestTube.png"),
]);

const jump = (name) => {
  console.log("bodornextnav path:", name);
  if (isVisitor == "false") {
    router.push({
      name: `${name}`,
      params: {
        isVisitor: "false",
      },
    });
  } else {
    router.push({
      name: `${name}`,
      params: {
        isVisitor: "true",
      },
    });
  }
};
</script>

<style scoped>
#download {
  padding: 100px 0px;
  background-color: #f7f9fa;
}
.zeropadding {
  padding: 0px;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
  min-height: 400px;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
}
.item {
  position: relative;
  height: 400px;
  background-color: #ffffff;
  border: 1px solid #bbbbbb;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  width: 30%;
}
.imgbox {
  position: relative;
  width: 100%;
  height: 85%;
  background-color: #fbfbfb;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.imgbox:hover .downloadbtn {
  opacity: 1;
}
.imgbox:hover .mask {
  opacity: 0.9;
}
.downloadbtn {
  background: #0064c8;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
  transition: all 0.3s;
  padding: 5px 10px;
  cursor: pointer;
  color: white;
  line-height: 30px;
  text-align: center;
  opacity: 0;
}
.mask {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
  transition: all 0.3s;
}
.bottom {
  width: 100%;
  height: 20%;
  padding-left: 12px;
}
.title {
  color: #333;
  letter-spacing: 0;
  line-height: 20px;
  margin: 5px 0px;
  font-weight: 500;
  font-size: 16px;
}
.text {
  line-height: 18px;
  font-size: 14px;
  color: #666;
}
@media (max-width: 767px) {
  .card-content {
    flex-direction: column;
  }
  .item {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
